<template>
    <Dialog v-model:visible="display" :modal="true" :baseZIndex="106" :class="['medium', {'green': passwordChanged}]">

        <h2 v-if="!passwordChanged">Hallo {{user}}</h2>
        <strong v-else><CheckIcon style="width: 25px; color: #16A34A; position: relative; top: 6px;" /> Ihr Passwort wurde erfolgreich geändert.</strong>

        <div class="p-mt-4">
            <p v-if="shouldChangePassword && !passwordChanged" class="p-mb-5">Ihr Account ist nun erfolgreich verifiziert. Bitte wählen Sie ein neues Passwort für Ihren Account.</p>
            <p v-else class="p-mb-3">Ihr Account ist nun vollständig eingerichtet. Sie können die Plattform nun ohne die erneute Eingabe Ihrer Daten nutzen - kostenlos und uneingeschränkt.</p>

            <div v-if="shouldChangePassword">
                <div v-if="!passwordChanged">
                    <div class="password-form p-fluid">
                        <span class="p-float-label">
                            <Password id="new-password" v-model="password" autocomplete="one-time-code"
                                      :mediumRegex="mediumRegex"                                      
                                      :strongRegex="strongRegex"
                                      :feedback="password?.length > 0"                                      
                                      toggleMask
                                      data-cy="reg-password" autofocus>
                                <template #header>
                                    <h3>Wählen Sie Ihr Passwort</h3>
                                    <h6>Passwortstärke</h6>
                                </template>
                                <template #footer="sp">
                                    {{sp.level}}
                                      <Divider />
                                      <h6>Ihr Passwort muss Folgendes enthalten:</h6>
                                    <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                                        <li>Mindestens 8 Zeichen</li>
                                    </ul>
                                </template>
                            </Password>
                            <label for="new-password">Neues Passwort</label>
                        </span>

                        <div class="p-mt-5 p-mb-3">
                            <Button label="Speichern" @click="changePassword" data-cy="button-change-password" />
                        </div>                        
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="password-form"><Button label="Schließen" @click="close" data-cy="close-reg-form"/></div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts" setup>

    import { ref, getCurrentInstance, defineEmits, defineExpose } from "vue";
    import { createAuthenticationService } from '../services/authenticationService';
    import { CheckIcon } from '@heroicons/vue/solid';
    const emit = defineEmits(['closed']);

    const app = getCurrentInstance();
    const password = ref();
    const display = ref(false);
    const passwordChanged = ref(false);
    const shouldChangePassword = ref(false);
    const user = ref("");

    const service = createAuthenticationService(app);

    const changePassword = async function () {
        await service.changePassword(app, password.value);
        passwordChanged.value = true;
    }

    const show = (customer, changePassword) => {
        display.value = true;
        shouldChangePassword.value = changePassword;
        user.value = customer.firstName + " " + customer.lastName;
    };

    const close = async () => {
        display.value = false;
        if (!shouldChangePassword.value) 
            emit("closed");
    }

    const mediumRegex = ref('^(?=.{8,})');
    const strongRegex = ref('^(?=.{12,})');

    defineExpose({
        show
    });

</script>
